export const USER_ACTIONS = {
    SET_CID: "SET_CID",
    SET_GCID: "SET_GCID",
    SET_EMAIL: "SET_EMAIL",
    SET_NAME: "SET_NAME",
    SET_USER_AGE_RANGE: "SET_USER_AGE_RANGE",
    SET_USER_GENDER: "SET_USER_GENDER",
    SET_USER_GOAL: "SET_USER_GOAL",
    SET_LINKED_EMAIL: "SET_LINKED_EMAIL",
    SET_USER_ORDER_ID: "SET_USER_ORDER_ID",
    SET_SOCIAL_PROVIDER: "SET_SOCIAL_PROVIDER",
    SET_SOCIAL_PROFILE_EMAIL: "SET_SOCIAL_PROFILE_EMAIL",
    SET_ANALYTICS_TRACKED: "SET_ANALYTICS_TRACKED",
    SET_PAYMENT_BACK_PATH: "SET_PAYMENT_BACK_PATH",
    SET_DEVICE_ID: "SET_DEVICE_ID",
    SET_HOLIDAY_PROMO_STATE: "SET_HOLIDAY_PROMO_STATE",
    SET_MULTIPLE: "SET_MULTIPLE",
} as const;

export const USER_DATA_STORAGE_KEY = "MemoryOSuState";

export const AGE_RANGE_MAPPING: Record<string, string> = {
    '18-24': '18-24',
    '25-34': '25-54',
    '35-44': '25-54',
    '45-54': '25-54',
    '55-64': '55',
    '65+': '55'
};

export const API_RETRY_COUNT = 5;
export const API_RETRY_DELAY_MS = 1000;

export const GOOGLE_ANALYTICS_ID = "G-QWT83PZ7FZ";
